module.exports = __webpack_public_path__ + "media/images/no_content.icon.companies-372fe3a3.png";